import { z } from 'zod';

export const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code == z.ZodIssueCode.invalid_union_discriminator) {
    return { message: 'Invalid selection' };
  }

  if (issue.code === z.ZodIssueCode.invalid_type) {
    if (issue.expected === 'date') {
      return { message: `'${ctx.data}' is not a valid date, expected format 'YYYY - MM - DD'` };
    }

    if (issue.received === 'null' || issue.received === 'undefined') {
      return { message: 'Required' };
    }
  }
  // Any error type not handled will fall back to this one
  return { message: ctx.defaultError };
};

z.setErrorMap(customErrorMap);
